import React from 'react';
import PropTypes from 'prop-types';

import { getFormData } from 'utils/form';

const Form = ({ isAltForm, isFormTypeIncome, ...props }) => {
  const handleFormSubmission = (event, callback) => {
    event.preventDefault();

    const values = getFormData(
      event.currentTarget,
      isAltForm,
      isFormTypeIncome,
    );

    return callback(values, event);
  };

  return (
    <form
      {...props}
      onSubmit={(event) => handleFormSubmission(event, props.onSubmit)}
    >
      {props.children}
    </form>
  );
};

Form.propTypes = {
  children: PropTypes.node.isRequired,
  onSubmit: PropTypes.func,
  isAltForm: PropTypes.bool,
  isFormTypeIncome: PropTypes.bool,
};

Form.defaultProps = {
  onSubmit: () => {},
  isAltForm: false,
  isFormTypeIncome: false,
};

export default Form;
